<app-party-quick-create-dialog
    [visible]="displayModal"
    (visibleChange)="onVisibilityChanged($event)"
    [mode]="mode"
    [record]="customer"
    [countries]="countries"
    [owningCompany]="owningCompany"
    [linkedCompany]="linkedCompany"
    [companyRequired]="companyRequired"
    [titleOverride]="dialogHeader"
    [submitLabel]="submitButtonLabel"
    (created)="onDialogCompleted($event)"
    (failed)="onDialogFailed()">
</app-party-quick-create-dialog>
